import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Admin.css";
import axios from "axios";

const LogistikRP = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 8;
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchPanenData();
  }, []);

  const fetchPanenData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_panen",
        { withCredentials: true }
      );
      const panens = response.data?.panens || [];
      const sortedData = panens.sort((a, b) => (b.id || 0) - (a.id || 0));
      setTableData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "Gagal memuat data rencana panen.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDetail = (id) => {
    navigate(`/logistikrpld/${id}`);
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout error fallback:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleBack = () => {
    navigate("/logistik");
  };

  const handleAjukan = async (id) => {
    const result = await Swal.fire({
      title: "Ajukan Penanganan Pengiriman",
      text: `Anda yakin ingin mengajukan armada logistik untuk menangani Rencana Panen #${id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: '<i class="fa fa-paper-plane me-1"></i> Ajukan Sekarang',
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          "https://c-greenproject.org:7500/ajukan_pengiriman",
          { rencana_panen_id: id },
          { withCredentials: true }
        );

        Swal.fire({
          title: "Berhasil!",
          text: response.data.message || "Permohonan pengiriman berhasil diajukan.",
          icon: "success",
          confirmButtonColor: "#198754",
          customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
        });
        fetchPanenData();
      } catch (error) {
        Swal.fire({
          title: "Gagal",
          text: error.response?.data?.error || "Terjadi kesalahan saat pengajuan.",
          icon: "error",
          confirmButtonColor: "#198754",
        });
      }
    }
  };

  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s.includes("selesai") || s.includes("panen") || s.includes("disetujui") || s.includes("approved")) {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1.5 rounded-pill fw-semibold">
          Approved
        </span>
      );
    }
    if (s.includes("tolak") || s.includes("batal") || s.includes("reject")) {
      return (
        <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1.5 rounded-pill fw-semibold">
          Rejected
        </span>
      );
    }
    return (
      <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-1.5 rounded-pill fw-semibold text-capitalize">
        {status || "Diajukan"}
      </span>
    );
  };

  const filteredData = useMemo(() => {
    const query = searchTerm.toLowerCase().trim();
    return tableData.filter((item) => {
      const id = String(item.id || item.rencana_panen_id || "");
      const nama = String(item.nama || "").toLowerCase();
      const alamat = String(item.alamat || "").toLowerCase();
      return id.includes(query) || nama.includes(query) || alamat.includes(query);
    });
  }, [tableData, searchTerm]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* 
        Perluasan CSS untuk menyembunyikan auto-pagination dari library luar. 
        Ditambahkan class umum dari DataTables & Simple-DataTables 
      */}
      <style>{`
        .dataTables_paginate,
        .dataTables_info,
        .dataTables_length,
        .dataTables_filter,
        .dataTables_wrapper .dataTables_paginate,
        .dataTable-pagination,
        .dataTable-info,
        .dataTable-top,
        .dataTable-bottom,
        .dt-paging,
        .dt-info,
        .dt-length,
        .dt-search {
          display: none !important;
        }
      `}</style>

      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" /> {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/logistik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/logistikp")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistikp" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistikp" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Shipping" /> Pengiriman
            </div>
            <div
              onClick={() => navigate("/logistikrp")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/logistikrp") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.includes("/logistikrp") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Daftar Rencana Panen</h2>
              <p className="text-muted small mb-0">
                Pilih dan ajukan armada logistik untuk memfasilitasi panen sawit dari para petani.
              </p>
            </div>
            <button
              className="btn btn-outline-secondary rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left me-2"></i>Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Card */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
              <div>
                <h4 className="fw-bold text-success mb-1">Jadwal Rencana Panen Petani</h4>
                <span className="text-muted small">Total: {filteredData.length} rencana panen terdata</span>
              </div>

              {/* Search Bar */}
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control rounded-pill px-3 py-2 shadow-none"
                  style={{ fontSize: "0.85rem", width: "250px", borderColor: "#cbd5e1" }}
                  placeholder="Cari Petani / Alamat / ID..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat jadwal rencana panen...</p>
              </div>
            ) : currentItems && currentItems.length > 0 ? (
              <>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                    <thead className="table-light text-nowrap">
                      <tr>
                        <th className="text-center py-3" style={{ width: "50px", borderTopLeftRadius: "10px" }}>No</th>
                        <th className="text-center py-3" style={{ width: "80px" }}>ID</th>
                        <th className="py-3 px-3" style={{ width: "200px" }}>Nama Petani</th>
                        <th className="py-3 px-3" style={{ width: "230px" }}>Alamat Lahan</th>
                        <th className="text-center py-3" style={{ width: "130px" }}>Tgl Panen</th>
                        <th className="text-center py-3" style={{ width: "130px" }}>Status</th>
                        <th className="text-center py-3" style={{ width: "150px" }}>Resi Pengiriman</th>
                        <th className="text-center py-3" style={{ width: "180px", borderTopRightRadius: "10px" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item, index) => {
                        const panenId = item.id || item.rencana_panen_id;
                        const rawResi = item.resi_pengiriman || item["Resi pengiriman"] || item.resi;
                        const resiList = Array.isArray(rawResi)
                          ? rawResi.filter(Boolean)
                          : typeof rawResi === "string" && rawResi.trim() !== ""
                          ? [rawResi]
                          : [];

                        const isAssigned = item.logistik_id !== null && item.logistik_id !== undefined;

                        return (
                          <tr key={`panen-${panenId || index}`}>
                            <td className="text-center fw-bold text-muted">
                              {startIndex + index + 1}
                            </td>
                            <td className="text-center font-monospace fw-semibold text-secondary">
                              #{panenId}
                            </td>
                            <td className="fw-semibold text-dark text-capitalize px-3">
                              {item.nama || "-"}
                            </td>
                            <td className="text-secondary small px-3 text-truncate" style={{ maxWidth: "230px" }}>
                              {item.alamat || "-"}
                            </td>
                            <td className="text-center text-dark fw-medium small">
                              {item.tanggal_panen || "-"}
                            </td>
                            <td className="text-center">
                              {getStatusBadge(item.status)}
                            </td>
                            <td className="text-center font-monospace">
                              {resiList.length > 0 ? (
                                <span className="badge bg-light text-dark border px-2 py-1">
                                  {resiList.join(", ")}
                                </span>
                              ) : (
                                <span className="text-muted small fst-italic">Belum Ada</span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                <button
                                  className="btn btn-sm rounded-pill px-3 fw-semibold shadow-sm"
                                  style={{
                                    color: "#198754",
                                    borderColor: "#198754",
                                    backgroundColor: "#ffffff",
                                    borderWidth: "1.5px",
                                    borderStyle: "solid",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#198754";
                                    e.currentTarget.style.color = "#ffffff";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                    e.currentTarget.style.color = "#198754";
                                  }}
                                  onClick={() => handleDetail(panenId)}
                                >
                                  Detail
                                </button>

                                {!isAssigned && resiList.length === 0 && (
                                  <button
                                    className="btn btn-sm rounded-pill px-3 fw-semibold shadow-sm"
                                    style={{
                                      backgroundColor: "#198754",
                                      borderColor: "#198754",
                                      color: "#ffffff",
                                      borderWidth: "1.5px",
                                      borderStyle: "solid",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = "#157347";
                                      e.currentTarget.style.borderColor = "#157347";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = "#198754";
                                      e.currentTarget.style.borderColor = "#198754";
                                    }}
                                    onClick={() => handleAjukan(panenId)}
                                  >
                                    Ajukan
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Asli (React) */}
                {totalPages > 1 && (
                  <nav className="mt-4">
                    <ul className="pagination justify-content-end mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-start-pill"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={`page-logrp-${index + 1}`}
                          className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link shadow-none"
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-end-pill"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-calendar-times mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Tidak Ada Rencana Panen Ditemukan</h5>
                <p className="mb-0">Belum ada jadwal panen terdaftar atau tidak cocok dengan pencarian.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogistikRP;